import { statesData } from "@/components/common/addressInput/common";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button } from "@/pages/quiz/15000/components/Button";
import { Select } from "@/pages/quiz/15000/components/Select";

const availableStateOptions = statesData.map((state) => ({
  value: state.abbreviation,
  label: state.state,
}));

const SelectState = ({
  setQuestionAnswer,
  questionValue,
  setQuestionValue,
}: QuizQuestionProps<string>) => {
  const defaultValue = availableStateOptions.find(
    (option) => option.value === questionValue
  );

  return (
    <>
      <Select
        placeholder="Select a state"
        options={availableStateOptions}
        defaultValue={defaultValue}
        onValueChange={setQuestionValue}
      />

      <Button
        disabled={!questionValue}
        onClick={() => setQuestionAnswer(questionValue)}
      />
    </>
  );
};

export { SelectState };
